export const setLocalStorageItem = (key: string, value: string): void => {
    localStorage.setItem(key, value);
};

export const getLocalStorageItem = (key: string): string | null => {
    const data = localStorage.getItem(key);
    return data;
};

export const removeLocalStorageItem = (key: string): void => {
    localStorage.removeItem(key);
};

export const setSessionStorageItem = (key: string, value: string): void => {
    sessionStorage.setItem(key, value);
};

export const getSessionStorageItem = (key: string): string | null => {
    const data = sessionStorage.getItem(key);
    return data;
};

export const removeSessionStorageItem = (key: string): void => {
    sessionStorage.removeItem(key);
};